module.exports = __webpack_public_path__ + "img/balcon-3.ceb49a60.jpg";